import Spinner from './Spinner';

const LoadingScreen = ({ fullPage = false, small = false, label = 'Loading...', showLabel = false }) => (
  <div className={`d-flex justify-content-center align-items-center gap-2${fullPage ? ' min-vh-100 bg-light' : ' py-5'}`}>
    <Spinner small={small} color="var(--field-green)">
      <span className="visually-hidden">{label}</span>
    </Spinner>
    {showLabel && <span className="text-muted small" aria-hidden="true">{label}</span>}
  </div>
);

export default LoadingScreen;
